<template>
  <main class="common-container">
    <section class="page-title flash-title common-padding">
      <h2>{{ $t("chart1.scoreChart") }}</h2>
    </section>

    <section class="explanation-container center">
      <img :src="explainImg" alt="" />
    </section>

    <section class="explanation-container center">
      <ul class="color-circle">
        <li class="color-circle__item">
          <p v-html="$t('scoreExp.descText2')"></p>
        </li>
        <li class="color-circle__item">
          <div class="div-gap">
            <p v-html="$t('scoreExp.descText3')"></p>
          </div>
          <div class="div-gap">
            <p v-html="$t('scoreExp.descText4')"></p>
          </div>
          <div class="div-gap">
            <p v-html="$t('scoreExp.descText5')"></p>
          </div>
          <div class="div-gap">
            <p v-html="$t('scoreExp.descText6')"></p>
          </div>
        </li>
      </ul>
    </section>
  </main>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from "vue";
import { useResolutionStore } from "@/store/useResolution";
import scoreImg from "@/assets/images/pages/explanation/score/score_demo.png";
import scoreMImg from "@/assets/images/pages/explanation/score/score_demo-m.png";

const resolutionStore = useResolutionStore();
const isMobile = computed(() => resolutionStore.isMobile);
// isMobile 값이 변경될 때 자동으로 업데이트됨
const explainImg = computed(() => (isMobile.value ? scoreMImg : scoreImg));

const updateWindowSize = () => {
  resolutionStore.setSize({ width: window.innerWidth });
};

onMounted(() => {
  window.addEventListener("resize", updateWindowSize);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWindowSize);
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pages/explanation/common_explanation.scss";
</style>
